module.exports = __webpack_public_path__ + "static/media/banner_casino.368ae9a9.png";